<template>
    <b-card :header="caption" v-if="items.length > 0 || loading">
          <div class="center" v-show="loading"><rotate-square  /></div>

      <b-table 
        v-if="!loading && items.length > 0"
        :hover="true"
        sort-icon-left
        responsive="sm" 
        :items="items" 
        :fields="captions" 
        striped
        :per-page="25">
        <template v-slot:cell(acoes)="data" >
            
            <div class="btn-group-sm" v-if="data.item.status == 'Pendente' && PerfilUsuarioLogado == 3"> 
                <b-button  variant="warning"  @click="clickedit(data.item)" style="margin-right:10px " title="Rejeitar" >
                    <i class="fa fa-edit" style="color: black"></i>
                </b-button>
            </div>

            <div class="btn-group-sm" v-if="data.item.status == 'Confirmado'"> 
              <b-button  variant="danger"  @click="clicklixeira(data.item)" title="Excluir">
                  <i class="fa fa-trash" style="color: black"></i>
              </b-button>
            </div>
        </template>
        <template v-slot:cell(dataCadastro)="data" >
            <div>
                <span> 
                    {{ data.item.dataCadastro | formatarData }}
                </span>
            </div>
        </template>
        <template v-slot:cell(centroDeCusto.descricao)="data" >
            <div>
                <span 
                    :style="{ 
                    backgroundColor: data.item.centroDeCusto.cor,
                    borderRadius: '3px',
                    padding: '2px' 
                }"> 
                    {{ data.item.centroDeCusto.descricao }}
                </span>
            </div>
        </template>
        <template v-slot:cell(status)="data" >
            <div>
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
            </div>
        </template>

      </b-table>
      <nav>
        <b-pagination-nav
          size="md" 
          :number-of-pages="totalDePaginas" 
          v-model="currentPage" 
          :link-gen="linkGen" 
          >
        </b-pagination-nav>
      </nav>
      <b-modal 
        title="Confirmar solicitação"
        class="modal-danger" 
        v-model="openModalConfirm" 
        hide-footer>
        <div class="d-flex flex-column">

            Toda solicitação de exclusão de pesagem é necessario confirmação por um administrador!
            
            <h5>Preencha uma justificativa:</h5>
            <b-alert v-if="mensagem" dismissible show :variant="mensagem.tipo"> {{mensagem.mensagem}} </b-alert>
            <input id="Justificativa" v-model="Justificativa" class="form-control" type="text" />
            <b-button variant="danger" @click="remove()" title="Enviar" style="margin-top: 5%;">
                <span>Confirmar</span>
            </b-button>
        </div>
      </b-modal>

      <b-modal 
        title="Solicitação de exclusão"
        class="modal-danger" 
        v-model="openModalEdit" 
        hide-footer>
        <b-card>
            <b-row>
                <h6>
                    Solicitado: 
                    {{itemEditar.dataAlteracao | formatarData }}
                </h6>                   
                <input id="usuario" v-model="itemEditar.usuarioAlteracao" class="form-control" disabled type="text" />
            </b-row>
            <b-row>
                    Justificativa:
                    <input id="justificativa" v-model="itemEditar.justificativa" class="form-control" disabled type="text" />
            </b-row>
        </b-card>
        <div class="d-flex flex-column">
            <small>*Ao negar o registro, ele volta-rá ao status confirmado</small>
            <small>*Ao aprovar o registro, ele ficará como excluido, e essa ação não poderá ser desfeita.</small>
            <div class="btn-group" >

                <b-button variant="danger" @click="negar()" title="Enviar" style="margin-top: 5%;">
                    <span>Negar</span>
                </b-button>
                <b-button variant="success" @click="aprovar()" title="Enviar" style="margin-top: 5%;">
                    <span>Aprovar</span>
                </b-button>
            </div>
        </div>
      </b-modal>
  
    </b-card>
  </template>
  <script>
  import {RotateSquare} from 'vue-loading-spinner'
  
  export default {
    name: 'grid-pesagem',
    components:{
      RotateSquare,
    },
    filters: {
        formatarData: function(value) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
        return new Date(value).toLocaleDateString('pt-BR', options);
        }
    },  
    inheritAttrs: false,
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      totalDePaginas: {
        type: Number,
        default: 1
      },
      fields: {
          type: [Array, Object],
          default: () => []
      },
      loading:{
        type: Boolean,
        default: true
      }
    },
    watch: {
      currentPage(){
        this.$emit("paginacao", this.currentPage )
      }
    },
    created() {
      this.currentPage = parseInt(this.$route.params.id)
    },
    data(){
      return {
        currentPage: 1,
        openModalConfirm: false,
        openModalEdit:false,
        itemEditar: {
            usuarioAlteracao:"",
            justificativa:"",
            dataAlteracao:"",
        },
        itemExcluir: null,
        Justificativa:null,
        mensagem:null,
        PerfilUsuarioLogado: this.$store.getters.getAutenticacao.perfil,
      }
    },
    computed: {
      items() {
        const items =  this.tableData
        return Array.isArray(items) ? items : items()
      },
      captions() { return this.fields }
    },
    methods: {
      getRowCount () {
        return this.items.length
      },
      remove(obj){
        if(this.Justificativa =="" || this.Justificativa == null ){
          this.mensagem = {tipo: "danger", mensagem: "É necessario informar uma justificativa! "}
          return;
        }else{

            this.openModalConfirm=false
            this.itemExcluir.Justificativa = this.Justificativa
            this.$emit('table-remove', this.itemExcluir)
            this.itemExcluir=null
        }
      },
      negar(obj){
        this.openModalEdit=false
        this.$emit('negar-exclusao', this.itemEditar)
        this.itemEditar=null
      },
      aprovar(obj){
        this.openModalEdit=false
        this.$emit('aprovar-exclusao', this.itemEditar)
        this.itemEditar=null
      },
      linkGen (pageNum) {
        this.$router.push({ path: `/pesagens/${pageNum}` });
      },
      clicklixeira(item){
        this.openModalConfirm=true
        this.itemExcluir=item
      },
      clickedit(item){
        //console.log(item)
        this.openModalEdit=true
        this.itemEditar=item
      },
      getBadge (status) {
        switch (status) {
            case "Confirmado":
                return  'success';
            case "Pendente":
                return  'secondary';
            case "Excluido":
                return  'danger';
            case "Finalizado":
            return  'info';
            default:
                return "secondary";
        }
      },
    }
  }
  </script>
  